import { requestAnimationFrame } from '../Lib/index.js';
export class Interval {
    static add(func, fps = 16, name = '') {
        name || (name = Math.random().toString(32).substr(2, 6));
        if (!this.instance) {
            Interval.start();
        }
        this.instance.intervals.push({
            fps,
            func,
            name,
        });
        return name;
    }
    static fps(name, fps, func) {
        this.instance.intervals.filter((interval) => {
            if (interval.name === name) {
                interval.fps = fps || interval.fps;
                interval.func = func || interval.func;
            }
        });
        return this.instance;
    }
    static list() {
        console.log(this.instance.intervals);
    }
    static remove(name) {
        this.instance.intervals = this.instance.intervals.filter((interval) => interval.name != name);
    }
    static start() {
        if (!this.instance) {
            this.instance = new Interval();
        }
        this.instance.unpause();
    }
    static stop() {
        if (!this.instance) {
            return;
        }
        this.instance.pause();
    }
    constructor() {
        this.enabled = false;
        this.intervals = [];
        this.lastFrameTime = 0;
        this.Handle_OnRequestAnimationFrame = this.Handle_OnRequestAnimationFrame.bind(this);
    }
    pause() {
        this.enabled = false;
    }
    unpause() {
        this.enabled = true;
        this.Handle_OnRequestAnimationFrame();
    }
    async Handle_OnRequestAnimationFrame() {
        if (!this.enabled) {
            return;
        }
        const now = Date.now();
        this.intervals.forEach((interval) => {
            const diff = now - (interval.lastTick || 0);
            if (diff > interval.fps) {
                interval.func({});
                interval.lastTick = now;
            }
        });
        this.lastFrameTime = Date.now();
        requestAnimationFrame(this.Handle_OnRequestAnimationFrame);
    }
}
//# sourceMappingURL=data:application/json;base64,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